import React from "react";

function Content() {
    return (
        <div>
            <div className="container content">
                <div className="row">
                    <div className="col-sm-3 talk">
                        <h1>Review PRs</h1>
                        <h1>Faster</h1>
                        <br />
                        <h6 className="bold-four">
                            Describer is a Chrome Extension that makes reviewing PRs faster by walking you through the changes line by line like a debugger.
                        </h6>
                        <br />
                        <h6><a className="btn btn-dark start start-two" href="https://chrome.google.com/webstore/detail/describer/beofflbjdakfgeglikjadebcgnjjkpdh" target="_blank" rel="noreferrer">Add to Chrome</a></h6>
                    </div>
                    <div className="col-sm-9 showcase-img">
                        {/* <div className="circle"></div> */}
                    </div>
                </div>
            </div>

            <section class="features-icons bg-light text-center det-ails">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                                <div class="features-icons-icon d-flex  icon-bra-ails">
                                    <i class="icon-check m-auto text-primary icon-ails"></i>
                                </div>
                                <h5>Easy to use</h5>
                                <p class="lead mb-0">The Describer extension modifies github pages for ease of use.</p>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                                <div class="features-icons-icon d-flex  icon-bra-ails">
                                    <i class="icon-lock m-auto text-primary icon-ails"></i>
                                </div>
                                <h5>Secure</h5>
                                <p class="lead mb-0">No code or personal data is ever stored.</p>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="features-icons-item mx-auto mb-0 mb-lg-3">
                                <div class="features-icons-icon d-flex  icon-bra-ails">
                                    <i class="icon-screen-desktop m-auto text-primary icon-ails"></i>
                                </div>
                                <h5>In Beta</h5>
                                <p class="lead mb-0">Currently this extension only works with Github.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Content;